import { render, staticRenderFns } from "./PageTitleDefault.vue?vue&type=template&id=647bd668"
import script from "./PageTitleDefault.vue?vue&type=script&lang=js"
export * from "./PageTitleDefault.vue?vue&type=script&lang=js"
import style0 from "./PageTitleDefault.vue?vue&type=style&index=0&id=647bd668&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports